<!-- @format -->

@if (studyRights$ | async; as studyRights) {
  <div class="col-sm-12 col-md-8 col-xl-8">
    @if (studyRights.length > 1) {
      <ng-container [ngTemplateOutlet]="select"></ng-container>
    }
    @if (studyRights.length === 1) {
      <ng-container [ngTemplateOutlet]="view"></ng-container>
    }
    @if (
      {
        courseUnit: enrolment.courseUnitId | courseUnit | async,
        courseUnitRealisation: enrolment.courseUnitRealisationId | courseUnitRealisation | async,
      };
      as enrolmentData
    ) {
      @if (enrolmentData.courseUnit && enrolmentData.courseUnitRealisation) {
        <div class="mt-3" aria-atomic="true" id="cu-notification">
          @if (showCourseUnitNotInPrimaryPlanNotification(studyRights, enrolmentData.courseUnit, enrolmentData.courseUnitRealisation)) {
            <sis-contextual-notification [content]="'ENROLMENTS.ENROLMENT_MODAL.CU_NOT_IN_PRIMARY_PLAN' | translate" variant="warning">
            </sis-contextual-notification>
          }
          @if (showCourseUnitNotInSelectionsNotification(studyRights, enrolmentData.courseUnit, enrolmentData.courseUnitRealisation)) {
            <sis-contextual-notification [content]="'ENROLMENTS.ENROLMENT_MODAL.CU_NOT_IN_SELECTIONS' | translate" variant="warning">
            </sis-contextual-notification>
          }
        </div>
      }
    }
    <ng-template #select>
      <label [ngClass]="getLabelState(control)" id="select-study-right-label" translate
        >ENROLMENTS.STUDY_RIGHT
        <select
          [formControl]="control"
          [id]="id"
          [ngClass]="{ invalid: getLabelState(control) === 'invalid' }"
          aria-describedby="cu-notification"
          class="form-select form-control"
          aria-labelledby="select-study-right-label"
          data-cy="select-study-right">
          <option [ngValue]="null" disabled selected>{{ "ENROLMENTS.STUDY_RIGHT_SELECT" | translate }}</option>
          @for (sr of studyRights; track sr) {
            <option [ngValue]="sr.id"
              >{{ sr.educationId | education | async | entityName | localizedString }} ({{ "STUDY_RIGHT_STATE." + sr.state | translate }})
            </option>
          }
        </select>
        <sis-validation-errors [control]="control" [validationErrors]="control.errors"></sis-validation-errors>
      </label>
    </ng-template>
    <ng-template #view>
      <label for="study-right" translate>ENROLMENTS.STUDY_RIGHT</label>
      @if (studyRights.length === 1) {
        <p id="study-right" aria-labelledby="select-study-right" aria-describedby="cu-notification">
          {{ studyRights[0].educationId | education | async | entityName | localizedString }}
          ({{ "STUDY_RIGHT_STATE." + studyRights[0].state | translate }})
        </p>
      }
    </ng-template>
  </div>
}
